<template>
  <el-select
    :size="size"
    v-model="bindVal"
    :placeholder="placeholder||$t('portal.bi-zhong')"
    style="width: 100%"
    @change="(ev)=>handleChange(ev)"
    filterable
    :disabled="disabled"
    ref="curencySelect"
  >
    <el-option
      v-for="subItem in options"
      :key="subItem.id"
      :label="subItem.name"
      :value="formKey === 'currency_id' ? subItem.id : subItem.name"
    />
  </el-select>
</template>

<script>
/**
 * 币种选择器, 用法和el-select一样，已嵌入到BaseInfo和sizer/TableFilter
 */

export default {
  name: "CurrencySelect",
  props: {
    value: {
      type: [String, Boolean, Number],
    },
    // 接收的字段，默认是currency_id，否则为dcode
    formKey: {
      type: String,
      required: false,
      default: "currency_id",
    },
    placeholder: {
      type: String,
      default:"portal.bi-zhong",
    },
    disabled:{
      type:Boolean,
      default:false
    },
    size: {
      type: String,
      default: "mini",
    },
    url: {
      type: String,
      default: "",
    },
    selectOption:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      bindVal: "",
      options: [],
    };
  },
  watch: {
    value(val) { //实时监听修改，解决数据和视图不同步
      this.bindVal = val;
    },
    selectOption(val) {
      this.options = val;
    },
  },
  created() {
    this.bindVal = this.value;
    if(this.selectOption?.length){
      this.options=this.selectOption
      return
    }
    if(this.url) {
      this.$axios.$get(this.url).then(({data}) => {
        this.options = data.list.map(({ id, dcode }) => ({ id, name: dcode }));
      })
      return
    }
    // 请求接口或从store中取
    this.$store.dispatch("getCurrencyList").then((data) => {
      this.options = data.map(({ id, dcode }) => ({ id, name: dcode }));
    }).catch(() => {});
  },
  methods: {
    handleChange(value) {
      // 模拟formItem, 实现v-model
      this.$emit("input", value);
      this.$emit("change", value, this.options);
    },
    blur() {
      if(this.$refs.curencySelect?.blur) {
        this.$refs.curencySelect.blur()
      }
    }
  },
};
</script>
